/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { useEffect, useRef } from 'react';
import { arrayOf, string } from 'prop-types';
import { useDispatch } from 'react-redux';
import { emitProductImpression } from '../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';

const useVertexAIProductImpression = ({
    products, experiments, attributionToken, pageType, category,
}) => {
    const dispatch = useDispatch();
    // To avoid firing multiple events in case of re-renders
    const hasFired = useRef(false);

    useEffect(() => {
        if (
            !hasFired.current
            && products?.length > 0
            && experiments?.length > 0
        ) {
            const updatedExperiments = [...experiments];
            if (attributionToken) {
                experiments.forEach((exp) => {
                    updatedExperiments.push({
                        ...exp,
                        source: 'vertex-ai',
                        attributionToken,
                    });
                });
            }

            dispatch(emitProductImpression({
                productsPayload: {
                    products,
                },
                page: { type: pageType },
                experiments: updatedExperiments,
                category,
            }));

            hasFired.current = true;
        }
    }, [products, experiments, attributionToken, pageType]);
};

// Wrapper for class components to use the useVertexAIProductImpression hook
export const VertexAIImpressionTracker = ({
    products,
    experiments,
    attributionToken,
    pageType,
    category,
}) => {
    useVertexAIProductImpression({
        products, experiments, attributionToken, pageType, category,
    });
    return null;
};

VertexAIImpressionTracker.propTypes = {
    products: arrayOf(Object),
    experiments: arrayOf(Object),
    attributionToken: string,
    pageType: string,
    category: Object,
};

VertexAIImpressionTracker.defaultProps = {
    products: [],
    experiments: [],
    attributionToken: '',
    pageType: '',
    category: { id: '', name: '' },
};

export default useVertexAIProductImpression;
